import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createShortcuts = async (data) => {
  console.log(data);
  try {
    let res = await Api.post("/app-shortcuts", data);
    return res?.data;
  } catch (e) {
    console.log(e);
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getShortCutsDataLocation = async (query) => {
  try {
    let res = await Api.get("/app-shortcuts/location", {
      params: query,
      headers:{
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    });
  
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getShortCutsData = async (query) => {
  try {
    let res = await Api.get("/app-shortcuts", {
      params: query,
      headers:{
        "Authorization": `Bearer ${localStorage.getItem("token")}`
      }
    });
  
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deleteShortCutsData = async (id) => {
  try {
    let res = await Api.delete("/app-shortcuts/" + id);
  
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateShortCutsData = async (id, data) => {
  try {
    let res = await Api.patch("/app-shortcuts/" + id, data);
  
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const updatePosition = async (banners, query) => {
  try {
    let res = await Api.patch(
      "/app-shortcuts/relocate-position",
      banners,
      {
        params: query,
      }
    );

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};